import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class TextAlign extends AStringEnum
{
    public constructor(value:AString)
    {
        super(value, TextAlign._types);
    }

    public toString():string
    {
        return this.value ? this.value.toString() : null;
    }

    public static toCssJustifyContentString(value:TextAlign):'flex-start' | 'center' | 'flex-end' | 'stretch'
    {
        if( TextAlign.isLeft(value) )
            return 'flex-start';
        if( TextAlign.isCenter(value) )
            return 'center';
        if( TextAlign.isRight(value) )
            return 'flex-end';
        if( TextAlign.isJustify(value) )
            return 'stretch';
        return null;
    }

    public static toCssBackgroundPositionString(value:TextAlign):string
    {
        if( TextAlign.isJustify(value) )
            return 'center';

        return value.toString();
    }

    public static LEFT = new AString('left'); // TODO: Add Meta decorator
    public static CENTER = new AString('center');
    public static RIGHT = new AString('right');
    public static JUSTIFY = new AString('justify');

    private static _types:Array<AString> = [
        TextAlign.LEFT,
        TextAlign.CENTER,
        TextAlign.RIGHT,
        TextAlign.JUSTIFY,
    ];

    public static isLeft(align:TextAlign):boolean
    {
        return align && TextAlign.LEFT.isEqualTo(align.value);
    }

    public static isRight(align:TextAlign):boolean
    {
        return align && TextAlign.RIGHT.isEqualTo(align.value);
    }

    public static isCenter(align:TextAlign):boolean
    {
        return align && TextAlign.CENTER.isEqualTo(align.value);
    }

    public static isJustify(align:TextAlign):boolean
    {
        return align && TextAlign.JUSTIFY.isEqualTo(align.value);
    }

    public static left():TextAlign
    {
        return new TextAlign(TextAlign.LEFT);
    }

    public static center():TextAlign
    {
        return new TextAlign(TextAlign.CENTER);
    }

    public static right():TextAlign
    {
        return new TextAlign(TextAlign.RIGHT);
    }

    public static justify():TextAlign
    {
        return new TextAlign(TextAlign.JUSTIFY);
    }

    public static fromString(value:string):TextAlign
    {
        return new TextAlign(AString.fromString(value));
    }
}
